<p-contextMenu #contextMenu appendTo="body" [model]="items" styleClass="grid-context-menu"></p-contextMenu>
